
ko.bindingHandlers.slider = {
    init: function (element, valueAccessor, allBindings, viewModel, context) {
        console.log('AASSLIDEDEER');
        // Instantiate a slider
        var mySlider = $(element).bootstrapSlider();

        // Call a method on the slider
        var value = mySlider.bootstrapSlider('getValue');

        // For non-getter methods, you can chain together commands
        mySlider
            .bootstrapSlider('setValue', 5)
            .bootstrapSlider('setValue', 7);
    }
}